const BaseView = require('../templates-base');
const FormatFactory = require('../../../../factory/formats');
const GridThumbnailView = require('../../components/thumbnail/grid');

module.exports = BaseView.extend({
  columnWidth: 255,

  initialize: function (options) {
    this.tool = INKIVE.Tool.getInstance();
    this.canvas = this.tool.editor.canvas;

    this.getFormat(options).then(_.bind(function (format) {
      options.format = format;
      BaseView.prototype.initialize.call(this, options);
    }, this));
  },

  getFormat: function (options) {
    const deferred = $.Deferred();
    const getClosestFormat = _.bind(getCF, this);

    options.format && deferred.resolve(options.format);
    if (!options.format) {
      this.isCustomFormat = true;
      FormatFactory.getFormats().then(function (formats) {
        deferred.resolve(getClosestFormat(formats));
      });
    }

    return deferred.promise();

    function getCF (formats) {
      let format;
      let sizeDifference = Infinity;
      let ratioDifference = Infinity;
      const width = this.canvas.contentW;
      const height = this.canvas.contentH;
      const ratio = width / height;

      _.each(formats, function (f) {
        const pixelFormat = convertToPixels(f);
        const rd = Math.abs(ratio - pixelFormat.ratio);
        if (rd < ratioDifference) {
          const sd = Math.abs(width - pixelFormat.width) + Math.abs(height - pixelFormat.height);
          if (sd < sizeDifference) {
            format = f;
            sizeDifference = sd;
            ratioDifference = rd;
          }
        }
      });

      return format;

      function convertToPixels (format) {
        const w = INKIVE.Helpers.convertUnitsToPixels(format.width, format.unit);
        const h = INKIVE.Helpers.convertUnitsToPixels(format.height, format.unit);

        return _.extend(format, { width: w, height: h, ratio: w / h });
      }
    }
  },

  initDataLoading: function () {
    this.loadDataType = 'default';
    BaseView.prototype.initDataLoading.call(this);
  },

  loadData: function (repeat, end) {
    const onMoreData = _.partial(this.onMoreData, this.filterActionId);
    const isDefaultCall = this.loadDataType === 'default';

    this.end = end;
    this.repeat = repeat;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));

    isDefaultCall && INKIVE.Helpers.api(
      this.apiCall, 'GET', this.getParams(), onMoreData
    );

    isDefaultCall || INKIVE.Helpers.sendCmd(
      INKIVE.C.BASE_URL + 'grid/fetch', this.getParams(), onMoreData
    );
  },

  getParams: function () {
    if (this.loadDataType !== 'default') {
      return _.extend({
        number_of_photos: ++this.numberOfPhotos
      }, this.size);
    }

    return BaseView.prototype.getParams.call(this);
  },

  onMoreData: function (faId, result) {
    if (faId !== this.filterActionId) return;

    const isDefaultCall = this.loadDataType === 'default';
    result = isDefaultCall ? result : JSON.parse(result);
    const hasResults = isDefaultCall
      ? result.data.length > 0
      : result.STATUS === 'SUCCESS';

    if (hasResults) {
      isDefaultCall && this.appendThumbnails(result.data);
      isDefaultCall || this.appendGridThumbnails(result.MESSAGE);
      this.repeat();
    } else if (this.loadDataType === 'default') {
      this.numberOfPhotos = 0;
      this.loadDataType = 'grid';
      this.from = 0;
      this.setGridTemplateFormat();
      this.repeat();
    } else {
      this.end();
      INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
    }

    INKIVE.Helpers.initTooltips(this.$el);
    this.scrollRefresh();
  },

  setGridTemplateFormat: function () {
    const convertToPixels = INKIVE.Helpers.convertUnitsToPixels;
    const $firstThumbnail = this.$el.find('.thumbnail-wrapper .thumbnail ').first();
    const thumbWidth = $firstThumbnail.width() || this.columnWidth;
    const canvas = this.tool.editor.canvas;

    this.callFormat = this.isCustomFormat ? {
      width: canvas.contentW,
      height: canvas.contentH
    } : {
      width: convertToPixels(this.format.width, this.format.unit),
      height: convertToPixels(this.format.height, this.format.unit)
    };

    this.size = {
      width: thumbWidth,
      height: thumbWidth * (this.callFormat.height / this.callFormat.width)
    };
  },

  appendGridThumbnails: function (data) {
    const $scrollDetect = this.$el.find('.thumbnail-wrapper .scrollDetect');

    _.each(data, function (item) {
      const $thumbnailView = $('<li>').addClass('thumbnail grid')
        .insertBefore($scrollDetect);

      new GridThumbnailView({
        el: $thumbnailView,
        size: this.size,
        format: this.callFormat,
        data: item,
        numberOfPhotos: this.numberOfPhotos
      });
    }, this);
  }
});
